import request from '@/utils/request';
import { BASE_API } from '@/utils/consts'

// 保存脑健康检测结果
export function saveDetectionResult(data) {
  return request(`${BASE_API}/detection/save`, {
    method: 'post',
    data
  })
}

// 查看某个客户脑健康检测历史记录
export function getDetectionHistoryRecords({customerId, pageNo = 1, pageSize = 10, ...other} = {}) {
  return request(`${BASE_API}/detection/list/${customerId}`, {
    data: {
      pageNo,
      pageSize,
      ...other
    }
  });
}

// 查看某次检测结果
export function getDetectionResult(taskId) {
  return request(`${BASE_API}/detection/show/${taskId}`);
}

// 查询某次预约创建的检测任务
export function getDetectionsByReservationItemId(reservationItemId) {
  return request(`${BASE_API}/task/detection/list/${reservationItemId}`);
}
